import { ChatContext } from 'context/Context';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { useContext, useEffect, useRef, useState } from 'react';
import SimpleBarReact from 'simplebar-react';
import Message from './Message';
import ThreadInfo from './ThreadInfo';

const ChatContentBody = ({ conversation }) => {
  let lastDate = null;
  const chatContainerRef = useRef();

  const [higlightedMessage, setHiglightedMessage] = useState(null);

  const { scrollToMessage, setScrollToMessage } = useContext(ChatContext);

  useEffect(() => {
    if (scrollToMessage) {
      setTimeout(() => {
        const element = document.getElementById(`message-${scrollToMessage}`);

        element?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }, 500);

      setHiglightedMessage(scrollToMessage);
      setScrollToMessage(null);
    }
  }, [scrollToMessage]);

  useEffect(() => {
    setTimeout(() => {
      if (chatContainerRef.current) {
        chatContainerRef.current.getScrollElement().scrollTop =
          chatContainerRef.current.getScrollElement().scrollHeight;
      }
    }, 0);
  }, [conversation]);

  return (
    <div className="chat-content-body pt-2" style={{ display: 'inherit' }}>
      <ThreadInfo conversation={conversation} />

      <SimpleBarReact style={{ height: '100%' }} ref={chatContainerRef}>
        <div className="chat-content-scroll-area">
          {conversation?.messages.map(message => {
            const { created_at, id } = message;
            const time = dayjs(created_at);

            return (
              <div key={id} id={`message-${id}`}>
                {lastDate !== time.format('DD/MM/YYYY') && (
                  <div className="text-center fs--2 text-500">
                    {time.format('DD/MM/YYYY, HH:mm')}
                  </div>
                )}
                {(() => {
                  lastDate = time.format('DD/MM/YYYY');
                })()}
                <Message
                  message={message}
                  time={time}
                  isGroup={conversation.type === 'group'}
                  isHighlighted={higlightedMessage === id}
                />
              </div>
            );
          })}
        </div>
      </SimpleBarReact>
    </div>
  );
};

ChatContentBody.propTypes = {
  conversation: PropTypes.object.isRequired
};

export default ChatContentBody;
